module.exports = __webpack_public_path__ + "static/animation2-eda4394c089bfe7e2eab7bb0d07ca5a0.mp4";